import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { rows } from "../MastersFakeDb";
import { editDeleteCylinderStatus, getCylinderStatusList } from "../../../actions/actions";
const CylinderStatusList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);

  const rows = useSelector((state) => state.cylinder_status.cylinder_status);
  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "dress_type", "cost"];
  const labels = ["Id", "dress_type", "cost"];

  // const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = "test";
  // const respMsgState = useSelector((state) => state.industry.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = () => {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    dispatch(getCylinderStatusList(params));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getCylinderStatusList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => {}, [shouldShowMsg, responseMessage]);

  const deleteRecord = (id) => {
    dispatch(
      editDeleteCylinderStatus({ cyl_status_id: id, changedUpdatedValue: "delete" })
    );
    setIsDelete(false);
    fetchData();
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

    const [successMessage, setSuccessMessage] = useState(null);
          //const respMsgState = 'test'
          const respMsgState = useSelector((state) => state.cylinder_status.message);
  
          const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
               useEffect(() => {
                      if (respMsgState) {
                          setSuccessMessage(respMsgState);
                      }
                  }, [respMsgState]);
              useEffect(() => {
              }, [shouldShowMsg, responseMessage,]);
  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "Cylinder Status List" },
          ]}
        />
        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.form_title}`}>
                  Cylinder Status List
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              md={5}
              sm={6}
              xs={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Box className={`${styles.excel_box}`}>
                <ExcelDownload
                  data={rows}
                  fields={fields}
                  labels={labels}
                  filename="Charges List"
                />
              </Box>
              <SearchInput value={searchKey} onChange={handleSearch} />
              <AddButton to="/masters/add-cylinder_status" label="" />
            </Grid>
          </Grid>
        </Box>
        <TableContainer
          component={Paper}
          className={`${styles.list_tbl_container}`}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Action
                </StyledTableCell>
                <StyledTableCell
                  align="right"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("cyl_status", sortBy, setSortBy, rows)
                  }
                >
                  Cylinder Status 
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "cyl_status" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(rows) &&
                rows.map((row, index) => (
                  <StyledTableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/masters/add-cylinder_status"
                      />
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      className={`${styles.list_table_body}`}
                    >
                      {row.cyl_status}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          onPageChange={handleChangePage}
          page={controller.page}
          count={rows && (rows[0]?.total_count || 0)}
          rowsPerPage={controller.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.cyl_status_id || null}
          displayName={deleteInfo?.cyl_status || ""}
        />
        <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={(event, reason) => HandleCloseSnackbar(event, reason, setSuccessMessage)}
                    message={successMessage}
                    action={ActionMsg(setSuccessMessage)}
                />
      </Paper>
    </>
  );
};
export default CylinderStatusList;
